/**
 * Before you edit these, read the documentation on how these files are compiled:
 * https://docs.phpvms.net/developers/building-assets
 *
 * Edits here don't take place until you compile these assets and then upload them.
 * Available providers: https://leaflet-extras.github.io/leaflet-providers/preview/
 */

const leaflet = require('leaflet');
require('leaflet-providers');

const OPENSTREETMAP_PROVIDER = 'OpenStreetMap.Mapnik';
const CARTO_TILE_URL = 'https://{s}.basemaps.cartocdn.com/{variant}/{z}/{x}/{y}{r}.png';
const CARTO_VARIANTS = {
  'CartoDB.Positron': 'light_all',
  'CartoDB.PositronNoLabels': 'light_nolabels',
  'CartoDB.DarkMatter': 'dark_all',
  'CartoDB.DarkMatterNoLabels': 'dark_nolabels',
};

export default (_opts) => {
  const opts = Object.assign({
    render_elem: 'map',
    center: [29.98139, -95.33374],
    zoom: 5,
    maxZoom: 10,
    layers: [],
    set_marker: false,
    leafletOptions: {},
  }, _opts);

  const leafletOptions = Object.assign({
    center: opts.center,
    zoom: opts.zoom,
    scrollWheelZoom: false,
    providers: {},
  }, opts.leafletOptions);

  // Check if any providers are listed; if not, set the default
  if (Object.entries(leafletOptions.providers).length === 0) {
    leafletOptions.providers = {
      [OPENSTREETMAP_PROVIDER]: {},
    };
  }

  const map = leaflet.map(opts.render_elem, leafletOptions);

  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const key in leafletOptions.providers) {
    if (Object.prototype.hasOwnProperty.call(CARTO_VARIANTS, key)) {
      const providerOptions = Object.assign({}, leafletOptions.providers[key]);
      const apiKey = providerOptions.apiKey || '';
      delete providerOptions.apiKey;

      // Honor the requested CARTO provider instead of replacing it with OSM.
      leaflet.tileLayer(
        CARTO_TILE_URL + (apiKey ? '?key={apiKey}' : ''),
        Object.assign({
          variant: CARTO_VARIANTS[key],
          apiKey: encodeURIComponent(apiKey),
          attribution: '&copy; OpenStreetMap contributors &copy; CARTO',
          subdomains: 'abcd',
          maxZoom: 20,
        }, providerOptions),
      ).addTo(map);
    } else {
      leaflet.tileLayer
        .provider(key, leafletOptions.providers[key])
        .addTo(map);
    }
  }

  return map;
};
